import * as types from "~/store/user/userType";

export const getUserInfoByCode = code => {
  return {
    type: types.GET_USER_INFO_BY_CODE,
    code
  };
};
export const logOut = () => {
  return {
    type: types.USER_LOG_OUT
  };
};
export const logOutWithoutNoti = () => {
  return {
    type: types.USER_LOG_OUT_WITHOUT_NOTI
  };
};

export const loginByFirebase = idToken => {
  return {
    type: types.LOGIN_BY_FIREBASE,
    idToken
  };
};

export const loginByZalo = code => {
  return {
    type: types.LOGIN_BY_ZALO,
    code
  };
};

export const loginSMSGetCode = phone => {
  return {
    type: types.GET_CODE_LOGIN_SMS,
    phone
  };
};
export const loginSMSCheckCode = (phone, code) => {
  return {
    type: types.CHECK_CODE_LOGIN_SMS,
    code,
    phone
  };
};
export const resetDataLoginSMS = () => {
  return {
    type: types.RESET_DATA_LOGIN_SMS
  };
};

export const registerSMSGetCode = () => {
  return {
    type: types.GET_CODE_REGISTER_SMS
  };
};

export const registerSMSCheckCode = code => {
  return {
    type: types.CHECK_CODE_REGISTER_SMS,
    code
  };
};

export const applyPassRegisterSMS = () => {
  console.log("action");
  return {
    type: types.APPLY_PASS_REGISTER_SMS
  };
};

export const loginWithPass = () => {
  return {
    type: types.LOGIN_WITH_PASSWORD
  };
};

export const storeSocialInfo = (socialToken, typeAccess) => {
  return {
    type: types.STORE_SOCIAL_INFO,
    socialToken,
    typeAccess
  };
};

export const applySignInWithSocial = (secretKey, tokenSocial) => {
  return { type: types.REGISTER_SOCIAL, secretKey, tokenSocial };
};
export const setTypeSocial = type => {
  return { type: types.SET_TYPE_SOCIAL, payload: type };
};

export const LoginWithSocial = tokenSocial => {
  return { type: types.LOGIN_SOCIAL_SIGNIN, tokenSocial };
};

export const forgotPassword = () => {
  return {
    type: types.FORGOT_PASSWORD
  };
};

export const forgotPasswordCheckCode = code => {
  return {
    type: types.CHECK_CODE_FORGOT_PASSWORD,
    code
  };
};

export const checkCodeForgotPassword = code => {
  return {
    type: types.CHECK_CODE_FORGOT_PASSWORD,
    code
  };
};

export const applyNewPassWord = () => {
  return {
    type: types.APPLY_PASS_FORGOT_PASSWORD
  };
};

export const clearInterval = () => {
  return {
    type: types.CLEAR_INTERVAL
  };
};

export const clearError = () => {
  return {
    type: types.CLEAR_ERROR
  };
};
export const clearOTPInfo = () => {
  return {
    type: types.CLEAR_OTP_INFO
  };
};

// Tách repo
export const loginFromMedproId = info => {
  return {
    type: types.LOGIN_FROM_MEDPRO_ID,
    payload: info
  };
};
